const API_URL = 'https://api-support-system.sulopa.com/api/v1/';
const SOCKET_URL = 'https://api-support-system.sulopa.com';

export { API_URL, SOCKET_URL };
